import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IconContainer = styled.div`
  margin-right: ${Spacing.S8};
`

export const Container = styled.div`
  width: 100%;
  min-height: 730px;
  position: relative;
`

export const FrodaIframe = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
`
